/**
 * Preview mode banner component.
 * Displays a prominent banner when the portal is accessed via a preview domain.
 *
 * @module components/layout/PreviewBanner
 */

import { ExternalLink, FlaskConical } from 'lucide-react';
import { config } from '@/config';

/**
 * Banner displayed at the top of the page when in preview mode.
 * Shows a link to the stable portal for users who want production-ready features.
 */
export function PreviewBanner() {
  // Don't show banner on localhost or if no stable URL is configured
  if (!config.isPreviewMode || !config.stablePortalUrl) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-red-600 to-red-500 text-white px-4 py-2 text-sm font-medium flex items-center justify-center gap-2 shadow-md">
      <FlaskConical className="h-4 w-4 flex-shrink-0" />
      <span>
        You are using the <strong>Preview Portal</strong> with experimental features.
      </span>
      <a
        href={config.stablePortalUrl}
        className="inline-flex items-center gap-1 underline underline-offset-2 hover:text-red-100 transition-colors font-semibold"
      >
        Go to Stable Portal
        <ExternalLink className="h-3 w-3" />
      </a>
    </div>
  );
}

/** Height of the preview banner in pixels */
export const PREVIEW_BANNER_HEIGHT = 40;
